import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutFleetCodeList extends Layout {
    layoutheaderFleetCode: LayoutHeader;
    sourceFleet: DataSource;
    tableFleetCodes: Table;
}
